export const SessionStorageKeys = {
  // Tracks the current browser tab instance for logging and hydration.
  tabId: "browser_tab_id",
  // Stores the authenticated user payload for the current tab session.
  user: "user",
  // Remembers whether the unsupported browser warning was accepted in this tab.
  browserAccepted: "browser_accepted",
  // Keeps the in-progress native language selection across auth flows.
  tempNativeLanguage: "temp_native_lang",
  // Flags that a lesson had video disabled for post-session feedback.
  videoDisabled: "talaera_video_disabled",
  // Marks that the conversation is currently in screen sharing mode.
  shareScreenMode: "Talaera_share_screen_mode",
  // Keeps the admin-selected user timezone for the current tab only.
  adminUserTimezone: "talaera_admin_userTimezone",
  // Keeps the admin-selected user UTC offset for the current tab only.
  adminUserUtcOffset: "talaera_admin_userUTCOffset",
  // Keeps the admin-selected user location for the current tab only.
  adminUserLocation: "talaera_admin_userLocation",
} as const;

export const LocalStorageKeys = {
  // Temporarily holds a serialized sessionStorage snapshot for new tabs.
  sessionStorageSnapshot: "sessionStorage",
  // Caches the server-to-browser clock offset for timestamp calculations.
  serverTimeOffset: "talaera_server_offset",
  // Enables verbose client-side console logging when present.
  enableConsoleLogging: "enableConsoleLogging",
  // Persists the user's chosen interface language across visits.
  language: "language",
  // Caches translation payload metadata per language.
  translationLastModified: (lang: string) => `lastModified_${lang}`,
  // Caches Tokbox session bootstrap data between flows.
  tokboxSessionData: "tokbox_session_data",
  // Caches the native languages list fetched from the backend.
  nativeLanguages: "Talaera_native_languages",
  // Persists the admin monitoring time query string across reloads.
  adminMonitoringTime: "talaera_admin_monitoringTime",
  // Tracks recently opened students for quick access.
  recentStudents: "Talaera_recent_students",
  // Tracks recently used tags for quick reuse.
  recentTags: "Talaera_recent_tags",
  // Stores recent dictionary searches for suggestions.
  dictionaryPreviousSearch: "Talaera_dictionary_search",
  // Records whether the free-form editor tour has been shown.
  teacherExerciseFreeFormEditorTour: "Talaera_teacher_exerciseFreeFormEditorTour",
  // Records whether the fill-in-the-blanks editor tour has been shown.
  teacherExerciseFillBlanksEditorTour: "Talaera_teacher_exerciseFillBlanksEditorTour",
} as const;
